var GIGYA_PATH = 'https://www.nerdwallet.com/cdn/gigya';
export var DEFAULT_USER_IMAGE = "".concat(GIGYA_PATH, "/avatar_empty.png");
export var DEFAULT_PROVIDERS = [{
  icon: "".concat(GIGYA_PATH, "/facebook_15.png"),
  name: 'Facebook'
}, {
  icon: "".concat(GIGYA_PATH, "/twitter_15.png"),
  name: 'Twitter'
}, {
  icon: "".concat(GIGYA_PATH, "/googleplus_15.png"),
  name: 'Google'
}, {
  icon: "".concat(GIGYA_PATH, "/linkedin_15.png"),
  name: 'LinkedIn'
}, {
  icon: "".concat(GIGYA_PATH, "/yahoo_15.png"),
  name: 'Yahoo'
}, {
  icon: "".concat(GIGYA_PATH, "/messenger_15.png"),
  name: 'Microsoft'
}, {
  icon: "".concat(GIGYA_PATH, "/aol_15.png"),
  name: 'AOL'
}];